export const typePrefix = {
  INIT_APP : 'INIT_APP',
}
